import reactStringReplace from "react-string-replace";

export default function (value) {

  const newLineUnescapeText = value.replace(/\\n/g,'\n')

  const patterns = {
    "&lt;": "<",
    "&gt;": ">",
    "&amp;": "&",
    "&quot;": '"',
    "&#x27;": "'",
    "&#x60;": "`",
  };

  // アンエスケープ処理
  const unescapeText = newLineUnescapeText.replace(/&(lt|gt|amp|quot|#x27|#x60);/g, (match) => {
    return patterns[match];
  });



  let replacedText = reactStringReplace(
    unescapeText,
    /(https?:\/\/\S+)/g,
    (match, i) => (
      <a key={match + i} href={match} target="_blank" rel="noopener noreferrer">
        {match}
      </a>
    )
  );

  return replacedText;
}
